import { ServiceBase } from "services/base-service";
import type { AxiosResponse } from "axios";
import type { UsersPage, User, UserPUT } from "../types";

class UsersService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/Users`;

    this.deleteUser = this.deleteUser.bind(this);
  }

  async getUsers({ page = 0, pageSize = 100 }, abortController?: AbortController): Promise<UsersPage> {
    const url = `?page=${page}&pageSize=${pageSize}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async getUser(id: string, abortController?: AbortController): Promise<User> {
    const url = `/${id}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async saveUser(user: UserPUT, abortController?: AbortController): Promise<{ id: string }> {
    const response = await this.sendPut("", user, abortController);

    return response;
  }

  async deleteUser(id: string, abortController?: AbortController): Promise<string> {
    const url = `/${id}`;
    const response = await this.sendDelete(url, abortController);

    return response;
  }

  async resetUserPassword(id: string, abortController?: AbortController): Promise<AxiosResponse<any, any>> {
    const url = `/reset-password`;
    const params = { id };
    const response = await this.sendPatch(url, params, abortController);

    return response;
  }
}

const usersService = new UsersService();

export { usersService };
